"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var R = _interopRequireWildcard(require("ramda"));
var _utils = require("@trs/utils");
var _config = require("@trs/config");
var _helpers = require("./helpers");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var MediaObject = function MediaObject(_ref) {
  var type = _ref.type,
    src = _ref.src,
    alt = _ref.alt,
    readOnly = _ref.readOnly,
    imageFallback = _ref.imageFallback,
    recommendedMediaSizes = _ref.recommendedMediaSizes;
  var isImage = type === _config.MEDIA_TYPE.IMAGE;
  var mediaObject;
  if (isImage) {
    mediaObject = /*#__PURE__*/_react["default"].createElement("img", {
      src: src,
      alt: alt || 'Banner image',
      onError: function onError(e) {
        e.target.onerror = null;
        e.target.src = imageFallback;
      },
      className: "media-image media",
      title: alt
    });
    mediaObject = readOnly ? /*#__PURE__*/_react["default"].createElement("div", {
      className: "media"
    }, /*#__PURE__*/_react["default"].createElement("a", {
      href: src,
      target: "_blank",
      rel: "noopener noreferrer"
    }, mediaObject)) : /*#__PURE__*/_react["default"].createElement("div", {
      className: "media-wrapper media"
    }, mediaObject);
  } else {
    mediaObject = /*#__PURE__*/_react["default"].createElement("iframe", {
      height: _utils.isMobile ? _helpers.RECOMMENDED_MOBILE_SIZE[_helpers.MEDIA_COMPONENTS.BANNER].height : R.prop('height', recommendedMediaSizes) || _helpers.RECOMMENDED_SIZE[_helpers.MEDIA_COMPONENTS.BANNER].height,
      width: _utils.isMobile ? _helpers.RECOMMENDED_MOBILE_SIZE[_helpers.MEDIA_COMPONENTS.BANNER].width : R.prop('width', recommendedMediaSizes) || _helpers.RECOMMENDED_SIZE[_helpers.MEDIA_COMPONENTS.BANNER].height,
      src: (0, _helpers.transformUrl)(src),
      title: alt || 'Video-Title',
      frameBorder: "0"
    });
  }
  return mediaObject;
};
MediaObject.defaultProps = {
  type: _config.MEDIA_TYPE.IMAGE,
  src: '',
  alt: '',
  readOnly: false,
  imageFallback: null,
  recommendedMediaSizes: {}
};
MediaObject.propTypes = {
  type: _propTypes["default"].string,
  src: _propTypes["default"].string,
  alt: _propTypes["default"].string,
  readOnly: _propTypes["default"].bool,
  recommendedMediaSizes: _propTypes["default"].shape({})
};
var _default = exports["default"] = MediaObject;